import type { Role } from '@lms/shared-types'
import { apiRequest } from './client'

export interface RoleSetResult {
  id: string
  roles: Role[]
}

/** Replace an employee's full role set (admin+ only). */
export function setEmployeeRoles(
  employeeId: string,
  roles: Role[],
): Promise<RoleSetResult> {
  return apiRequest<RoleSetResult>(
    `/api/v1/admin/employees/${employeeId}/roles`,
    { method: 'PUT', body: { roles } },
  )
}
